import React, { useEffect, useState } from "react";
import Nav from "./nav";
import Method from "./method";
import Mobile from "./mobile";
import Adhaar from "./adhaar";
import AdhaarOTP from "./adhaar-otp";
import Address from "./address";
import Confirmation from "./confirmation";
import DrivingOTP from "./dl-otp";
import DrivingAddress from "./dl-address";
import DrivingConfirmation from "./dl-confirmation";

function CreateAbha({ setCreateABHApopUp, createABHApopUp }) {
  const [method, setMethod] = useState("adhaar");
  const [status, setStatus] = useState("Method Selection");
  const [position, setPosition] = useState(0);
  const [adhaarAccessToken, setAdhaarAccessToken] = useState("");
  const [adhaarX_Token, setAdhaarX_Token] = useState("");

  const [adhaarTokenExpiresIn, setAdhaarTokenExpiresIn] = useState("");
  const [txnId, setTxnId] = useState("");
  const [message, setmessage] = useState("");
  const [drivingSuccessData, setDrivingSuccessData] = useState(null);
  const [adhaarSuccessData, setAdhaarSuccessData] = useState(null);
  const [newABHAaddress, setNewABHAaddress] = useState(null);

  const [adhaarNo, setAdhaarNo] = useState("");

  const closeModal = () => {
    setCreateABHApopUp(false);
  };

  // Handle ESC key press
  // useEffect(() => {
  //   const handleEscape = (e) => {
  //     if (e.key === "Escape" && createABHApopUp) {
  //       closeModal();
  //     }
  //   };

  //   document.addEventListener("keydown", handleEscape);
  //   return () => document.removeEventListener("keydown", handleEscape);
  // }, [createABHApopUp]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (createABHApopUp) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [createABHApopUp]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-[rgba(0,0,0,0.7)] backdrop-blur-sm z-[2200]"
      // onClick={handleOverlayClick}
    >
      <div className="bg-white w-[80%] h-[90%] rounded-lg flex flex-col overflow-hidden text-[var(--abha-fg)]">
        {/* Fixed Nav Section */}
        <div className="flex-shrink-0 p-6 pb-0">
          <Nav
            method={method}
            setMethod={setMethod}
            status={status}
            setStatus={setStatus}
            position={position}
            setPosition={setPosition}
          />
        </div>

        {/* Scrollable Content Section */}
        <div className="flex-1 overflow-y-auto custom-scrollbar px-6 ">
          {status === "Method Selection" && (
            <Method
              closeModal={closeModal}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
          {status === "Aadhar Details" && (
            <Adhaar
              closeModal={closeModal}
              setmessage={setmessage}
              message={message}
              setTxnId={setTxnId}
              setAdhaarTokenExpiresIn={setAdhaarTokenExpiresIn}
              setAdhaarAccessToken={setAdhaarAccessToken}
              setAdhaarNo={setAdhaarNo}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
          {status === "OTP Verification" && method === "adhaar" && (
            <AdhaarOTP
              setAdhaarX_Token={setAdhaarX_Token}
              setAdhaarSuccessData={setAdhaarSuccessData}
              closeModal={closeModal}
              tokenExpiresIn={adhaarTokenExpiresIn}
              txnId={txnId}
              setmessage={setmessage}
              message={message}
              setTxnId={setTxnId}
              adhaarNo={adhaarNo}
              
              adhaarAccessToken={adhaarAccessToken}
              setAdhaarTokenExpiresIn={setAdhaarTokenExpiresIn}
              setAdhaarAccessToken={setAdhaarAccessToken}
              setAdhaarNo={setAdhaarNo}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
          {status === "ABHA Address" && method === "adhaar" && (
            <Address
              setNewABHAaddress={setNewABHAaddress}
              closeModal={closeModal}
              txnId={txnId}
              setmessage={setmessage}
              message={message}
              setTxnId={setTxnId}
              adhaarNo={adhaarNo}
              adhaarAccessToken={adhaarAccessToken}
              setAdhaarTokenExpiresIn={setAdhaarTokenExpiresIn}
              setAdhaarAccessToken={setAdhaarAccessToken}
              setAdhaarNo={setAdhaarNo}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
          {status === "Confirmation" && method === "adhaar" && (
            <Confirmation
              newABHAaddress={newABHAaddress}
              adhaarX_Token={adhaarX_Token}
              adhaarSuccessData={adhaarSuccessData}
              closeModal={closeModal}
              txnId={txnId}
              setmessage={setmessage}
              message={message}
              setTxnId={setTxnId}
              adhaarNo={adhaarNo}
              adhaarAccessToken={adhaarAccessToken}
              setAdhaarTokenExpiresIn={setAdhaarTokenExpiresIn}
              setAdhaarAccessToken={setAdhaarAccessToken}
              setAdhaarNo={setAdhaarNo}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
          {status === "Mobile Number" && method === "driving" && (
            <Mobile
              closeModal={closeModal}
              txnId={txnId}
              setmessage={setmessage}
              message={message}
              setTxnId={setTxnId}
              adhaarNo={adhaarNo}
              adhaarAccessToken={adhaarAccessToken}
              setAdhaarTokenExpiresIn={setAdhaarTokenExpiresIn}
              setAdhaarAccessToken={setAdhaarAccessToken}
              setAdhaarNo={setAdhaarNo}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
          {status === "OTP Verification" && method === "driving" && (
            <DrivingOTP
              closeModal={closeModal}
              tokenExpiresIn={adhaarTokenExpiresIn}
              txnId={txnId}
              setmessage={setmessage}
              message={message}
              setTxnId={setTxnId}
              adhaarNo={adhaarNo}
              adhaarAccessToken={adhaarAccessToken}
              setAdhaarTokenExpiresIn={setAdhaarTokenExpiresIn}
              setAdhaarAccessToken={setAdhaarAccessToken}
              setAdhaarNo={setAdhaarNo}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
          {status === "ABHA Address" && method === "driving" && (
            <DrivingAddress
              setDrivingSuccessData={setDrivingSuccessData}
              closeModal={closeModal}
              tokenExpiresIn={adhaarTokenExpiresIn}
              txnId={txnId}
              setmessage={setmessage}
              message={message}
              setTxnId={setTxnId}
              adhaarNo={adhaarNo}
              adhaarAccessToken={adhaarAccessToken}
              setAdhaarTokenExpiresIn={setAdhaarTokenExpiresIn}
              setAdhaarAccessToken={setAdhaarAccessToken}
              setAdhaarNo={setAdhaarNo}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
          {status === "Confirmation" && method === "driving" && (
            <DrivingConfirmation
              drivingSuccessData={drivingSuccessData}
              closeModal={closeModal}
              tokenExpiresIn={adhaarTokenExpiresIn}
              txnId={txnId}
              setmessage={setmessage}
              message={message}
              setTxnId={setTxnId}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default CreateAbha;
